export default __webpack_public_path__ + "static/media/SEQ.3db6a991.png";